module.exports = __webpack_public_path__ + "img/style_1_pl.e01e6bb7.jpeg";